<template>
  <gj-modal
      v-bind="$attrs"
      size="normal"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="$emit('cancel')"
      @confirm="confirm()">
    <template #header>调整预算</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          >
        <el-form-item
            prop="budget.value"
            :rules="[
              { required: true, message: '请输入调整值', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(2), '请输入最多2位小数的正整数')
            ]">
          <gj-select-input
              v-model="form.budget"
              :options="options"
              :width="['160px', '150px']"
              :placeholder="['', '请输入']">
            <template #suffix>
              <span class="gj-input-suffix_icon">{{ icon }}</span>
            </template>
          </gj-select-input>
        </el-form-item>
      </el-form>
      <gj-import-alert
          :rules="[
            '选择将预算调整：直接输入目标预算',
            '按百分比提高/降低预算公式：目标预算 = 原始预算 * (100 ± 输入值) / 100',
            '按固定金额提高/减低预算公式：目标预算 = 原始预算 ± 输入值',
            '预算调整低于1单位金额时，系统会将预算调整为1',
            '预算调整四舍五入精确到小数点后两位数',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "../../../../../../minxins";
  import {transformToMap} from "../../../../../../utils/common";

  export default {
    name: "app-adjust-budget-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      currencySymbol: {
        type: String,
        default: null
      },
    },
    created() {
      this.options = [
        {id: 0, text: '将预算调整到', icon: this.currencySymbol},
        {id: 1, text: '按百分比提高预算', icon: '%'},
        {id: 2, text: '按百分比降低预算', icon: '%'},
        {id: 3, text: '按固定金额提高预算', icon: this.currencySymbol},
        {id: 4, text: '按固定金额降低预算', icon: this.currencySymbol},
      ];
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          budget: {
            key: 0,
            value: null
          }
        },
        options: []
      }
    },
    computed: {
      icon() {
        const option = transformToMap(this.options)[this.form.budget.key];
        return option ? option.icon : '';
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('confirm');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-form-item__error {
    padding-left: 160px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  /deep/ .el-input__suffix{
    right: 1px;
    top: 1px;
  }
  /deep/ .el-input__suffix-inner{
    height: calc(100% - 2px);
    width: 30px;
    display: inline-block;
  }
  .gj-input-suffix_icon{
    display: inline-block;
    height: 100%;
    width: 100%;
    background: #EEEFF0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.el-alert {
    padding: 8px 12px !important;
  }
  /deep/.gj-alert-warning--border {
    border: 0;
  }
</style>
